/**
 * @fileoverview Taskflow - Content Area component React interface
 * @author Qiwen Luo (qluo@yext.com)
 */

import * as styles from '/ui/components/taskflow/contentArea/contentArea.module.scss';
import {LayoutHeader} from '/ui/components/taskflow/layoutHeader/layoutHeader';
import * as Types from '/ui/components/taskflow/models';

/**
 * @param {{
 *   layoutHeader?: Types.LayoutHeaderType,
 *   content: React.ReactNode,
 * }} props
 * @return {React.ReactElement}
 */
export function ContentArea({
  layoutHeader,
  content,
}) {
  return (
    <div className={styles.container}>
      {layoutHeader
        && (
          <div className={styles.layoutHeaderWrapper}>
            <LayoutHeader
              icon={layoutHeader.icon}
              title={layoutHeader.title}
              description={layoutHeader.description}
              resourceLink={layoutHeader.resourceLink}
            />
          </div>
        )
      }
      {content}
    </div>
  );
}
